import dayjs from 'dayjs';

export const transformDataToPiePeriodChart = (data: any[]) => {
  if (!data || !Array.isArray(data)) {
    return { series: [], labels: [] };
  }

  // Define time periods (2-hour intervals)
  const timePeriods = [
    '00:00 - 02:00',
    '02:00 - 04:00',
    '04:00 - 06:00',
    '06:00 - 08:00',
    '08:00 - 10:00',
    '10:00 - 12:00',
    '12:00 - 14:00',
    '14:00 - 16:00',
    '16:00 - 18:00',
    '18:00 - 20:00',
    '20:00 - 22:00',
    '22:00 - 00:00',
  ];

  // Initialize counts for each time period
  const periodCounts = timePeriods.map(period => ({
    time_period: period,
    count: 0,
  }));

  // Process each entry and count by time period
  data.forEach(entry => {
    const entryTime = dayjs(entry.date_time);
    const hour = entryTime.hour();

    // Determine which time period this entry belongs to
    let periodIndex = 0;
    if (hour >= 0 && hour < 2) periodIndex = 0;
    else if (hour >= 2 && hour < 4) periodIndex = 1;
    else if (hour >= 4 && hour < 6) periodIndex = 2;
    else if (hour >= 6 && hour < 8) periodIndex = 3;
    else if (hour >= 8 && hour < 10) periodIndex = 4;
    else if (hour >= 10 && hour < 12) periodIndex = 5;
    else if (hour >= 12 && hour < 14) periodIndex = 6;
    else if (hour >= 14 && hour < 16) periodIndex = 7;
    else if (hour >= 16 && hour < 18) periodIndex = 8;
    else if (hour >= 18 && hour < 20) periodIndex = 9;
    else if (hour >= 20 && hour < 22) periodIndex = 10;
    else if (hour >= 22 && hour < 24) periodIndex = 11;

    periodCounts[periodIndex].count++;
  });

  return {
    labels: periodCounts.map(period => period.time_period),
    series: periodCounts.map(period => period.count),
  };
};
